(function () {
  var docEl = document.documentElement;
  if (!docEl.classList.contains('motion')) return;

  // Staggered scroll reveals
  if ('IntersectionObserver' in window) {
    document.querySelectorAll('[data-reveal-group]').forEach(function (group) {
      var kids = group.querySelectorAll('.reveal');
      for (var i = 0; i < kids.length; i++) {
        kids[i].style.setProperty('--reveal-d', Math.min(i, 8) * 60 + 'ms');
      }
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  // Soft image load-in
  document.querySelectorAll('.pdp__slide img, .art__hero-media img').forEach(function (img) {
    if (img.complete) img.classList.add('is-loaded');
    else img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
  });
})();
